const initAnimations = () => {
    // 1. Header Scroll Effect
    const header = document.querySelector('header');
    if (header) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        });
    }

    // 2. Animate Elements on Scroll
    const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target); // Only animate once
            }
        });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach(el => observer.observe(el));
};

// Global Event Delegation for Mobile Menu
document.addEventListener('click', (e) => {
    // Open Menu
    const toggle = e.target.closest('.mobile-menu-toggle');
    if (toggle) {
        e.preventDefault(); // Prevent accidental form submissions or jumps
        document.body.classList.toggle('menu-open');
        console.log('Mobile menu toggled:', document.body.classList.contains('menu-open'));
    }

    // Close Menu on Link Click
    if (e.target.closest('.mobile-nav-links a')) {
        document.body.classList.remove('menu-open');
    }
});

document.addEventListener('DOMContentLoaded', initAnimations);

// Shopify Theme Editor Events
document.addEventListener('shopify:section:load', initAnimations);
document.addEventListener('shopify:section:select', initAnimations);
